export default __webpack_public_path__ + "static/media/prd10.896be8bf.jpg";